import { NotificationStyle } from './notifications.constants.js';

var Notification = /** @class */ (function () {
    function Notification(body, options, id) {
        this.body = body;
        this.style = options.style || NotificationStyle.INFO;
        this.dismissible = !!options.dismissible;
        this.id = id;
        this.closeDelay = options.closeDelay;
        this.onClose = options.onClose;
        this.uniqueID = options.uniqueID;
        this.label = options.label;
        this.url = options.url;
        this.hideCloseIcon = !!options.hideCloseIcon;
    }
    return Notification;
}());

export { Notification };
